/* eslint-disable no-nested-ternary */
import { useEffect, useState, useContext, createContext, useMemo ,useCallback } from "react";
import { useLocation } from 'react-router-dom'
import { message } from "antd";
import useHttpClient from 'shared/hooks/http-hook';
import { AuthContext } from 'shared/context/auth-context';
import EndPoints from 'shared/endPoints/EndPoints.json'

const PackageContext = createContext({
    contextIdentifier: null,
    contextResponse: null,
    isResponseDataNull: null,
    carrierCompany: null,
    deviceType: null,
    capacity: null,
    deviceTypeId: null,
    carrierCompanyId: null,
    remainingCapacity: null,
    barcodePrint: null,
    isNew: null,
    parcelId: null,
    useNewSIM: null,
    updateRemaingCapacity: () => { },
})

function PackageContextProvider({ children }) {
    const [carrierCompany, setCarrierCompany] = useState();
    const [deviceType, setDeviceType] = useState();
    const [isResponseDataNull, setIsResponseDataNull] = useState()
    const { sendRequest, responseData, requestIdentifier, status } = useHttpClient();
    const { UserId } = useContext(AuthContext);
    const { state } = useLocation()
    const [capacity, setCapacity] = useState()
    const [deviceTypeId, setDeviceTypeId] = useState()
    const [carrierCompanyId, setCarrierCompanyId] = useState()
    const [remainingCapacity, setRemainingCapacity] = useState()
    const [barcodePrint, setBarcodePrint] = useState()
    const [isNew, setIsNew] = useState()
    const [parcelId, setParcelId] = useState()
    const [useNewSIM, setUseNewSIM] = useState()
    const type = state === "Obd" ? 1 : state === "Bl" ? 2 : 5;

    useEffect(() => {
        sendRequest({
            endpoint: `${EndPoints.PARCEL.GETPARCELBYUSER}/${UserId}`,
            method: 'GET',
        },
            'GETPARCELBYUSER'
        )
        sendRequest({
            endpoint: EndPoints.DROPDOWN.CARRIERCOMPANY,
            method: 'GET'
        },
            'CARRIERCOMPANY'
        )
        sendRequest({
            endpoint: `${EndPoints.DROPDOWN.DEVICETYPES}?DeviceTypeId=${type}`,
            method: 'GET'
        },
            'DEVICETYPES'
        )
    }, [sendRequest, UserId,type])

    useEffect(() => {
        if (responseData && requestIdentifier === 'CARRIERCOMPANY') {
            setCarrierCompany(responseData)
        }
        if (responseData && requestIdentifier === 'DEVICETYPES') {
            setDeviceType(responseData)
        }
        if (responseData && requestIdentifier === 'GETPARCELBYUSER') {
            setCapacity(responseData.capacity)
            setDeviceTypeId((responseData.deviceTypeId === 0 && state === 'Bl') ? 3 : responseData.deviceTypeId)
            setCarrierCompanyId(responseData.carrierCompanyId)
            setRemainingCapacity(responseData.remainingCapacity)
            setBarcodePrint(responseData.barcodePrint)
            setIsNew(responseData.isNew)
            setParcelId(responseData.id)
            setUseNewSIM(responseData.useNewSIM)
        }
    }, [requestIdentifier, responseData,state])
    useEffect(() => {
        if (responseData?.id !== 0 && requestIdentifier === 'GETPARCELBYUSER') {
            setIsResponseDataNull(false)
        }
        if (responseData?.id === 0 && requestIdentifier === 'GETPARCELBYUSER') {
            setIsResponseDataNull(true)
        }
    }, [responseData, requestIdentifier])

    useEffect(() => {
        if (status === 'rejected') {
            let result;
            Object.keys(responseData).forEach((key) => {
                result = responseData[key]
            })
            message.error(result)
        }
    }, [status, responseData])

    const updateRemaingCapacity = useCallback((remainingPackageCapacity) => {
        setRemainingCapacity(remainingPackageCapacity)
    }, [])

    const memoedvalue = useMemo(() => ({
        carrierCompany,
        deviceType,
        contextResponse: responseData,
        contextIdentifier: requestIdentifier,
        isResponseDataNull,
        capacity,
        deviceTypeId,
        carrierCompanyId,
        remainingCapacity,
        barcodePrint,
        isNew,
        parcelId,
        useNewSIM,
        type,
        updateRemaingCapacity
    }), [carrierCompany,
        deviceType,
        responseData,
        requestIdentifier,
        isResponseDataNull,
        capacity,
        deviceTypeId,
        carrierCompanyId,
        remainingCapacity,
        barcodePrint,
        isNew,
        parcelId,
        useNewSIM,
        type,
        updateRemaingCapacity
    ]
    )

    return (
        <PackageContext.Provider value={memoedvalue}>
            {children}
        </PackageContext.Provider>
    );

}
function usePackage() {
    return useContext(PackageContext)
}

export { PackageContextProvider, usePackage, PackageContext }